import { graphql } from 'react-relay';
import type { GraphQLTaggedNode } from 'react-relay';

import { useEditorContentFragment } from '@confluence/editor-content-unified-query/entry-points/useEditorContentFragment.ts';
import type { EditorContentFragmentResult } from '@confluence/editor-content-unified-query/entry-points/useEditorContentFragment.ts';

import type { contentAppearanceQuery$data } from './__generated__/contentAppearanceQuery.graphql.ts';
import type { useContentAppearanceFragment_content$key } from './__generated__/useContentAppearanceFragment_content.graphql.ts';

// contentAppearanceQuery's selection for EditorContentUnifiedQuery; same fields and arguments, so
// both share the store records.
const contentAppearanceFragmentNode: GraphQLTaggedNode = graphql`
	fragment useContentAppearanceFragment_content on Content @catch {
		id
		appearanceDraft: properties(key: "content-appearance-draft") {
			nodes {
				id
				key
				value
				version {
					number
				}
			}
		}
	}
`;

/**
 * The content appearance from EditorContentUnifiedQuery in the shape of contentAppearanceQuery
 * data. When the fragment is provided, its reader skips contentAppearanceQuery, whose refetch still
 * updates the records the fragment reads.
 */
export function useContentAppearanceFragment({
	contentId,
}: {
	contentId: string;
}): EditorContentFragmentResult<contentAppearanceQuery$data> {
	return useEditorContentFragment<
		useContentAppearanceFragment_content$key,
		contentAppearanceQuery$data
	>('contentAppearanceFragment', contentAppearanceFragmentNode, {
		contentId,
		mapData: (value) => ({ content: { nodes: [value] } }),
	});
}
